import {
  createActionGroup,
  createFeature,
  createReducer,
  emptyProps,
  on,
  props,
} from '@ngrx/store';
export const ProtocolWorkActions = createActionGroup({
  source: 'Protocol work',
  events: {
    Refresh: emptyProps(),
    Invalidate: emptyProps(),
    Loaded: props<{ count: number }>(),
    Failed: emptyProps(),
    Reset: emptyProps(),
  },
});
export const protocolWorkFeature = createFeature({
  name: 'protocolWork',
  reducer: createReducer(
    { count: null as number | null, generation: 0 },
    on(ProtocolWorkActions.loaded, (state, { count }) => ({
      count,
      generation: state.generation,
    })),
    on(ProtocolWorkActions.invalidate, (state) => ({
      ...state,
      generation: state.generation + 1,
    })),
    on(ProtocolWorkActions.failed, (state) => ({ ...state, count: null })),
    on(ProtocolWorkActions.reset, (state) => ({
      count: null,
      generation: state.generation + 1,
    })),
  ),
});
